import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { navSelector } from 'common/store/modules/competition-nav/selectors';

export const NavItem = ({ value, onClick, isCurrent }) => {
    const nav = useSelector(navSelector);
    const isActive = nav.round.roundNumber === value;
    const label = value === 0 ? 'OR' : value;

    return (
        <li
            className={classnames(
                'player-awards-round-by-round__round-list-nav-item',
                { 'is-active': isActive },
                { 'is-current': isCurrent }
            )}
        >
            <button
                className="player-awards-round-by-round__round-list-nav-button"
                onClick={(event) => onClick(event, value)}
                tabIndex={0}
            >
                {label}
            </button>
        </li>
    );
};

NavItem.propTypes = {
    value: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    isCurrent: PropTypes.bool.isRequired
};
